// @flow

import React from 'react';
import Relay from 'react-relay/classic';
import { Link } from 'react-router';

import AgentStateIcon from 'app/components/agent/state-icon';

import Badge from 'app/components/shared/Badge';
import Panel from 'app/components/shared/Panel';
import JobLink from 'app/components/shared/JobLink';

type Props = {
  agent: {
    id: string,
    hostname: string,
    job?: {
      state: string
    },
    isRunningJob: boolean,
    metaData: Array<Object>,
    name: string,
    organization: {
      slug: string
    },
    public: boolean,
    uuid: string,
    version: string
  }
};

class AgentRow extends React.PureComponent<Props> {
  renderJob() {
    const { agent } = this.props;

    if (agent.isRunningJob) {
      const job = agent.job
        ? <JobLink job={agent.job} />
        : 'a job owned by another team';

      return (
        <small
          className="block mt1 pt1 border border-gray"
          style={{
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: 'none'
          }}
        >
          Running {job}
        </small>
      );
    }
  }

  render() {
    const { agent } = this.props;

    let metaDataContent = 'No metadata';
    if (agent.metaData.length > 0) {
      metaDataContent = agent.metaData.sort().join(' ');
    }

    return (
      <Panel.Row>
        <div className="flex">
          <AgentStateIcon agent={agent} className="pr3 pt1" />
          <div className="flex flex-auto flex-column">
            <div className="flex flex-auto">
              <div className="flex-auto col-8">
                <div className="truncate">
                  <Link
                    className="semi-bold black hover-lime text-decoration-none"
                    to={`/organizations/${agent.organization.slug}/agents/${agent.uuid}`}
                  >
                    {agent.name}
                  </Link>
                  {this.renderPublicBadge()}
                </div>
                <div className="small dark-gray wrap-break-word">{metaDataContent}</div>
              </div>
              <div className="flex-none right-align col-4 pl3">
                <div className="black">
                  {agent.version ? `v${agent.version}` : 'Unknown Version'}
                </div>
                <div className="small dark-gray truncate">{agent.hostname}</div>
              </div>
            </div>
            {this.renderJob()}
          </div>
        </div>
      </Panel.Row>
    );
  }

  renderPublicBadge() {
    if (this.props.agent.public) {
      return (
        <Badge outline={true} className="regular very-dark-gray" title="Visible to everyone, including people outside this organization">Public</Badge>
      );
    }
  }
}

export default Relay.createContainer(AgentRow, {
  fragments: {
    agent: () => Relay.QL`
      fragment on Agent {
        ${AgentStateIcon.getFragment('agent')}
        id
        hostname
        metaData
        name
        organization {
          slug
        }
        public
        isRunningJob
        job {
          ...on JobTypeCommand {
            state
          }
          ${JobLink.getFragment('job')}
        }
        uuid
        version
      }
    `
  }
});
